import { makeStyles } from '@material-ui/core';
import LoadingSpinner from 'components/LoadingSpinner';
import { Label } from 'components/shared';
import useFetchPdf from 'hooks/useFetchPdf';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles(theme => {
  const { palette } = theme;

  return {
    item: {
      cursor: 'pointer',
      color: palette.accent.main,
      height: '40px',
      '&:hover': {
        color: palette.primary.main,
        backgroundColor: palette.primary.light
      },
      padding: '8px 4px',
      display: 'flex',
      alignItems: 'center'
    },
    documentDate: {
      width: '100%'
    },
    loadingSpinner: {
      padding: '0'
    }
  };
});

const DocumentMenuItem = ({ document }) => {
  const classes = useStyles();
  const [isLoading, fetchPdf] = useFetchPdf({ id: document.documentId });

  return (
    <div role="none" className={classes.item} onClick={fetchPdf}>
      {isLoading ? (
        <LoadingSpinner size={18} classes={{ root: classes.loadingSpinner }} />
      ) : (
        <Label
          classes={{ root: classes.documentDate }}
          themeColor="primary"
          size="small"
          text={moment(document.reportDateEnd).format('MMMM YYYY').toUpperCase()}
        />
      )}
    </div>
  );
};

DocumentMenuItem.propTypes = {
  document: PropTypes.exact({
    documentId: PropTypes.number,
    documentType: PropTypes.string,
    rank: PropTypes.number,
    reportDateEnd: PropTypes.string
  }).isRequired
};

export default DocumentMenuItem;
